import React from "react";
import { BonusesSection } from "./components/BonusesSection";
import { Hero } from "./components/Hero";
import { LaunchBar } from "./components/LaunchBar";
import { ReceiveSection } from "./components/ReceiveSection";
import { SocialProofSection } from "./components/SocialProofSection";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-[#090B0D] font-heading" data-id="element-0" data-mp="3fbt2augtc72p">
      <LaunchBar data-id="element-1" data-mp="2rlypue0eokiz" />
      <main data-id="element-2" data-mp="2rlf6qtz0rq3d">
        <Hero data-id="element-3" data-mp="2rl6y5e9xj6xz" />
        <SocialProofSection data-id="element-4" data-mp="2riklj086m18w" />
        <ReceiveSection data-id="element-5" data-mp="2mmcc83go129n" />
        <BonusesSection data-id="element-6" data-mp="2mn5ash5h0lgp" />
      </main>
    </div>;
}